import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TrackingComponent } from 'src/app/components/tracking/tracking.component';
import { LoginComponent } from '../app/components/login/login.component';
import { TabsContainerComponent } from '../app/components/tabs-container/tabs-container.component';
import { UserConnectedGuard } from '../app/core/guards/user-connected.guard';
import { UserGrantedGuard } from '../app/core/guards/user-granted.guard';
import { Rights } from '../app/models/server/enums/rights';

const routes: Routes = [
    {
        path: '',
        component: TabsContainerComponent,
        canActivate: [UserConnectedGuard, UserGrantedGuard],
        data: {
            expectedRights: [Rights.BoxView, Rights.WorkflowView],
        },
    },
    { path: 'login', component: LoginComponent },
    { path: 'tracking', component: TrackingComponent },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule],
})
export class AppRoutingModule {}
